/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SendMessageViaProxy: BridgeCommands.Command<
    Types.Common.Nvappigoipcproxy.SendMessageViaProxyParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAppIgoIpcProxy',
    method: 'SendMessageViaProxy',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IpcProxyMessageNotification: BridgeCommands.Command<
    {},
    Types.Common.Nvappigoipcproxy.IpcProxyMessageNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAppIgoIpcProxy',
    method: 'IpcProxyMessageNotification',
    persistent: true
};

export const Nvappigoipcproxy = {
SendMessageViaProxy,
IpcProxyMessageNotification
};
